<template lang="pug">
  v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="workgroupRules"
    label='Workgroup'
    data-track="workgroup"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputWorkgroup extends Vue {
  workgroupRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Workgroup is required'];
}
</script>
